import { requestApiJson } from './client';

const getJson = async (path) => {
  const { data } = await requestApiJson(path, {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-cache' },
  });
  return data || {};
};

const filenameFromDisposition = (disposition) => {
  const s = String(disposition || '');
  const star = s.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) {
    try { return decodeURIComponent(star[1]); } catch { /* noop */ }
  }
  const plain = s.match(/filename="([^"]+)"/i);
  return plain ? plain[1] : 'chat-media.zip';
};

const postZipDownload = async (path, { imageIds = [], fileIds = [] } = {}) => {
  const { data, response: res } = await requestApiJson(path, {
    method: 'POST',
    body: { imageIds, fileIds },
  });
  if (!res.ok) {
    throw new Error(data?.message || 'ダウンロードに失敗しました。');
  }
  const blob = await res.blob();
  const filename = filenameFromDisposition(res.headers.get('Content-Disposition'));
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const buildAuthenticatedFileUrl = (path, item) => {
  const assetId = String(item?.assetId || '').trim();
  if (!path || !assetId) return '';
  return `/api${path}/${encodeURIComponent(assetId)}/download?proxy=stream`;
};

// base（例: /event-chat/events/xxx）に対する loadLinks/loadMedia/downloadZip を束ねる。
const makeSource = (base, fileDownloadPath = '') => ({
  loadLinks: (offset, limit) => getJson(`${base}/links/${offset}/${limit}`),
  loadMedia: (offset, limit) => getJson(`${base}/media/${offset}/${limit}`),
  downloadZip: (selection) => postZipDownload(`${base}/media/download-zip`, selection),
  buildFileUrl: fileDownloadPath
    ? (item) => buildAuthenticatedFileUrl(fileDownloadPath, item)
    : undefined,
});

export const eventChatAssetSource = (eventId) => makeSource(
  `/event-chat/events/${encodeURIComponent(eventId)}`,
  '/event-chat/files',
);
export const adminPersonalChatAssetSource = (artistId) => makeSource(
  `/admin/messages/${encodeURIComponent(artistId)}`,
  '/admin/messages/files',
);
export const artistPersonalChatAssetSource = () => makeSource(
  '/artist/messages',
  '/artist/messages/files',
);
export const adminGroupChatAssetSource = (threadId) => makeSource(`/admin/group-chat/threads/${encodeURIComponent(threadId)}`);
export const artistGroupChatAssetSource = (threadId) => makeSource(`/artist/group-chat/threads/${encodeURIComponent(threadId)}`);
